export default __webpack_public_path__ + "static/media/konsep_2..ff4969eb.png";